import Modal, { ModalProps } from "../Modal/Modal";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import { useTranslation } from "react-i18next";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import useDefaultAction from "../PosMenuAction/useDefaultAction";
import { useSetModal } from "@/shared/atoms/useModal";
import { DeliveryMethods } from "@/shared/utils/enum";
import PaymentAndDelivery from "../PosMenu/PaymentAndDelivery";
import { IconsVariant } from "../Icon/Icon";
import usePosOrderResetHook from "@/shared/hooks/usePosOrderResetHook";

const PosDeliveryMethodModal = ({ onExit, ...props }: ModalProps) => {
  const { posDeliveryMethods } = usePosSettingsHook();
  const { t } = useTranslation();
  const [deliveryMethod, setDeliveryMethod] = usePosOrderDeliveryMethod();
  const setDefaultAction = useDefaultAction();
  const setModal = useSetModal();
  const reset = usePosOrderResetHook();
  return (
    <Modal onExit={onExit} {...props}>
      <div className="grid grid-cols-2 gap-x-8 gap-y-12 pt-12">
        {posDeliveryMethods.map((item) => (
          <PaymentAndDelivery
            key={item.value}
            isSelect={item.value === deliveryMethod}
            name={t(item.translationKey)}
            icon={item.icon as IconsVariant}
            onClick={() => {
              reset();
              setDeliveryMethod(item.value);
              setDefaultAction();
              if (item.value === DeliveryMethods.DELIVERY) {
                setModal("orderUser", {
                  deliveryMethodId: item.value,
                });
                return;
              }
              onExit();
            }}
          />
        ))}
      </div>
    </Modal>
  );
};
export default PosDeliveryMethodModal;
